import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { childrenOf } from '../../../utils/custom-prop-types';
import GridColumn from '../GridColumn/GridColumn';

const GridRow = (props) => {
    const {
        bottomSpacing,
        bottomSpacingLess,
        children,
        className,
    } = props;
    const rowClassName = classNames('grid__row', {
        'grid__row--bottom-spacing': bottomSpacing,
        'grid__row--bottom-spacing-less': bottomSpacingLess,
    }, className);

    return (
        <div className={rowClassName}>
            {children}
        </div>
    );
};

GridRow.propTypes = {
    bottomSpacing: PropTypes.bool,
    bottomSpacingLess: PropTypes.bool,
    children: PropTypes.oneOfType([
        childrenOf(GridColumn),
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    className: PropTypes.string,
};

GridRow.defaultProps = {
    bottomSpacing: false,
    bottomSpacingLess: false,
    className: '',
    children: () => <React.Fragment />,
};

export default GridRow;
